const typographyPendente = {
  name: 'Olá, Guilherme Neves Herker',
  access: 'Seu acesso ainda não foi liberado',
  email: 'Você receberá um e-mail assim que seu acesso for aprovado pelo administrador do sistema',
  doubt: 'dúvidas? Entre em contato com',
  doubt1: 'ilton@adm.com'
};

export default typographyPendente;
